import React, { useRef } from 'react';

import MainButton from '@/components/UI/mobile/MainButton';

import styles from './index.module.scss';

type AddAndEditTodoModalProps = {
  closeModal: () => void;
  showOneCamera: {
    url: string;
    name: string;
  };
};

const ShowCameraDetail = ({
  closeModal,
  showOneCamera,
}: AddAndEditTodoModalProps) => {
  const modalRef = useRef<HTMLDivElement | null>(null);

  return (
    <div className={styles.modal} ref={modalRef}>
      <div className={styles.form}>
        <label htmlFor="title">{showOneCamera.name}</label>
        <img id="cameraFrame" src={showOneCamera.url} width="100%"></img>
      </div>
      <div className={styles.footerContainer}>
        <MainButton onClick={closeModal}>離開</MainButton>
      </div>
    </div>
  );
};

export default ShowCameraDetail;
